import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getCanonicalAndHreflang } from '../lib/i18n';

export default function SeoMeta({
  title,
  description,
  ogImage = 'https://assets.auxodev.dk/assets/28e87dfb-16e7-4c8a-a569-3940d683c543/pmb-logo.png',
  children,
}) {
  const location = useLocation();
  const { lang, canonicalUrl, hreflangDa, hreflangEn, hreflangDefault } =
    getCanonicalAndHreflang(location.pathname);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <Helmet>
      <html lang={lang} />
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonicalUrl} />
      <link rel="alternate" hrefLang="da" href={hreflangDa} />
      <link rel="alternate" hrefLang="en" href={hreflangEn} />
      <link rel="alternate" hrefLang="x-default" href={hreflangDefault} />

      {/* Open Graph */}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:locale" content={lang === 'en' ? 'en_US' : 'da_DK'} />
      {ogImage && <meta property="og:image" content={ogImage} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {children}
    </Helmet>
  );
}
